(function () {
  "use strict";

  class ConvxDesktopNav extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.announcementBar = null;
      this.lastScrollPos = 0;
      this.stickyTransitioning = false;
    }

    connectedCallback() {
      this.header = document.querySelector("#SiteHeader");
      this.announcementBar = document.querySelector(
        ".announcement-bar.new-announcement-bar"
      );

      if (window.innerWidth > 768) {
        this.initMenu();
      }
      this.initStickyHeader();

      window.addEventListener("scroll", this.handleScroll.bind(this));
      window.addEventListener("resize", this.updateHeaderOffsets.bind(this));

      window.addEventListener("load", () => {
        this.updateHeaderOffsets();
      });

      this.updateHeaderOffsets();
    }

    initMenu() {
      const dropDown = this.querySelectorAll(
        ".convx__desktop-menu > li > .convx__menu-link.desktop"
      );
      dropDown.forEach((item) => {
        item.addEventListener("click", (e) => this.disableClick(e));
        item.addEventListener("mouseenter", (e) => this.showDropdown(e));
      });

      const headerWrapper = document.querySelector(".header-wrapper--sticky");

      if (headerWrapper) {
        headerWrapper.addEventListener("mouseleave", () => {
          this.resetHeaderState();
        });
      }
      // reset when mouse leaves menu area
      const menuWrapper = this.querySelector(".convx__desktop-menu");
      if (menuWrapper) {
        menuWrapper.addEventListener("mouseleave", () => {
          this.activeDropdownRef = null;
        });
      }

      const first_level = this.querySelectorAll(
        ".convx__first-level-nav .convx__nav-collection-card"
      );
      first_level.forEach((link) => {
        link.addEventListener("click", (e) => this.showSecondLevel(e));
      });

      const sidebar = this.querySelectorAll(
        ".convx__nav-sidebar .convx__nav-sidebar-link"
      );
      sidebar.forEach((link) => {
        link.addEventListener("click", (e) => this.showThirdLevel(e));
      });

      const self = this;
      this.timeout = null;
      this.querySelectorAll(".convx__collection-nav-dropdown").forEach((dropdown) => {
        dropdown.addEventListener("mouseleave", () => {
          // clear previous timeout if exists
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            dropdown.classList.remove("active");

            const anyActive = this.querySelector(
              ".convx__collection-nav-dropdown.active"
            );
            if (!anyActive) {
              const shoppingBar = document.querySelector(".shopping-bar");
              if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
              const siteHeader = document.querySelector(
                ".header-wrapper--sticky .site-header"
              );
              const menuLink = document.querySelectorAll("a.convx__menu-link");
              const flag = document.querySelector(".regions-flag-small-btn");
              const logo = document.querySelectorAll(".site-header__logo img");
              const icons = document.querySelectorAll(
                ".header-item--icons .site-nav__link"
              );
              if (siteHeader) siteHeader.classList.remove("active");
              if (menuLink)
                menuLink.forEach((item) => {
                  item.classList.remove("active");
                });
              if (flag) flag.classList.remove("active");
              if (logo)
                logo.forEach((item) => {
                  item.classList.remove("active");
                });
              if (icons)
                icons.forEach((item) => {
                  item.classList.remove("active");
                });
            };

            this.timeout = null;
          }, 400); // 400ms delay
        });

        dropdown.addEventListener("mouseenter", () => {
          // Cancel if mouse comes back in
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
        });
      });

      const menuLinks = this.querySelectorAll(
        ".convx__desktop-menu > li"
      );

      menuLinks.forEach((li) => {
        li.addEventListener("mouseleave", () => {
          // If there is NO active dropdown, restore shopping bar
          const activeDropdown = this.querySelector(
            ".convx__collection-nav-dropdown.active"
          );

          if (!activeDropdown) {
            const shoppingBar = document.querySelector(".shopping-bar");
            if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
          }
        });
      });
    }

    resetHeaderState() {
      const dropdowns = this.querySelectorAll(".convx__collection-nav-dropdown");
      dropdowns.forEach(d => d.classList.remove("active"));

      const siteHeader = document.querySelector(".header-wrapper--sticky .site-header");
      const menuLinks = document.querySelectorAll("a.convx__menu-link");
      const flag = document.querySelector(".regions-flag-small-btn");
      const logos = document.querySelectorAll(".site-header__logo img");
      const icons = document.querySelectorAll(".header-item--icons .site-nav__link");

      if (siteHeader) siteHeader.classList.remove("active");
      if (menuLinks) menuLinks.forEach(item => item.classList.remove("active"));
      if (flag) flag.classList.remove("active");
      if (logos) logos.forEach(item => item.classList.remove("active"));
      if (icons) icons.forEach(item => item.classList.remove("active"));

      this.activeDropdownRef = null;

      const shoppingBar = document.querySelector(".shopping-bar");
      if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
    }

    disableClick(e) {
      const dropdownRef = e.target.textContent.trim();

      const dropdown = this.querySelector(
        `.convx__collection-nav-dropdown[data-nav-reference="${dropdownRef}"]`
      );

      // if dropdown exists → block click
      if (dropdown) {
        e.preventDefault();
      }
    }

    showDropdown(e) {
      const menuLinks = e.target.closest(".convx__menu-link");
      if (!menuLinks) return;

      const ref = menuLinks.textContent.trim();

      // 🚨 HARD GUARD: do nothing if already active
      if (this.activeDropdownRef === ref) return;
      this.activeDropdownRef = ref;

      const currentActive = this.querySelector(
        ".convx__collection-nav-dropdown.active"
      );
      if (currentActive) currentActive.classList.remove("active");

      const dropdownRef = e.target.textContent.trim();
      const dropdown = this.querySelector(
        `.convx__collection-nav-dropdown[data-nav-reference="${dropdownRef}"]`
      );

      // ONLY hide shopping bar if submenu exists
      if (dropdown) {
        const shoppingBar = document.querySelector(".shopping-bar");
        if (shoppingBar) {
          shoppingBar.classList.add("hide-shopping-bar");
          if (typeof window.stickyHeaderCheck === "function") {
            window.stickyHeaderCheck();
          }
        }
      }

      const siteHeader = document.querySelector(
        ".header-wrapper--sticky .site-header"
      );
      const menuLink = document.querySelectorAll("a.convx__menu-link");
      const flag = document.querySelector(".regions-flag-small-btn");
      const logo = document.querySelectorAll(".site-header__logo img");
      const icons = document.querySelectorAll(
        ".header-item--icons .site-nav__link"
      );
      if (dropdown) e.preventDefault();
      if (dropdown) dropdown.classList.add("active");
      if (siteHeader) siteHeader.classList.remove("active");
      siteHeader.classList.add("active");
      if (menuLink)
        menuLink.forEach((item) => {
          item.classList.remove("active");
          item.classList.add("active");
        });
      if (flag) flag.classList.remove("active");
      flag.classList.add("active");
      if (logo)
        logo.forEach((item) => {
          item.classList.remove("active");
          item.classList.add("active");
        });
      if (icons)
        icons.forEach((item) => {
          item.classList.remove("active");
          item.classList.add("active");
        });
    }

    showSecondLevel(e) {
      e.preventDefault();
      this.querySelectorAll(
        ".convx__first-level-nav .convx__nav-collection-card"
      ).forEach((item) => {
        item.classList.remove("active");
      });
      const targetElement = e.target.closest(".convx__nav-collection-card");
      if (targetElement) {
        targetElement.classList.add("active");
        const collectionRef = targetElement.dataset.navReference.trim();
        this.querySelectorAll(".convx__second-level-nav").forEach((el) =>
          el.classList.remove("active")
        );
        const target = this.querySelector(
          `.convx__second-level-nav[data-nav-reference="${collectionRef}"]`
        );
        if (target) target.classList.add("active");
      }
    }

    showThirdLevel(e) {
      e.preventDefault();

      const targetElement = e.target.closest(".convx__nav-sidebar-link");
      if (!targetElement) return;

      const seriesRef = targetElement.getAttribute("data-nav-reference");
      if (!seriesRef) return;

      const parentSecondLevel = targetElement.closest(
        ".convx__second-level-nav"
      );
      if (!parentSecondLevel) return;

      parentSecondLevel
        .querySelectorAll(".convx__nav-sidebar-link")
        .forEach((link) => {
          link.classList.remove("active");
        });

      parentSecondLevel
        .querySelectorAll(".convx__third-level-nav")
        .forEach((nav) => {
          nav.classList.remove("active");
        });

      targetElement.classList.add("active");

      const targetThirdLevel = parentSecondLevel.querySelector(
        `.convx__third-level-nav[data-nav-reference="${seriesRef}"]`
      );
      if (targetThirdLevel) {
        targetThirdLevel.classList.add("active");
      }
    }

    /** Sticky header behavior starts here **/

    initStickyHeader() {
      if (!this.header) return;
      this.header.classList.add("cc-header--sticky");
    }

    handleScroll() {
      if (this._scrollTicking) return;
      this._scrollTicking = true;

      requestAnimationFrame(() => {
        this._scrollTicking = false;

        if (!this.header || this.stickyTransitioning) return;

        const scrollTop = document.documentElement.scrollTop;

        if (scrollTop < 200) {
          this.showHeader();
        } else if (this.lastScrollPos < scrollTop) {
          this.hideHeader();
        } else if (this.lastScrollPos - 5 > scrollTop) {
          this.showHeader();
        }

        this.lastScrollPos = scrollTop;
      });
    }

    showHeader() {
      if (this.header.classList.contains("is-out")) {
        this.header.classList.remove("is-out");
        this.setHeaderEnd();
      }
    }

    hideHeader() {
      if (!this.header.classList.contains("is-out")) {
        this.header.classList.add("is-out");
        this.setHeaderEnd();
      }
    }

    updateHeaderOffsets() {
      if (!this.header) return;

      let totalHeight = this.header.offsetHeight;
      if (this.announcementBar) {
        totalHeight += this.announcementBar.offsetHeight;
      }

      const headerEnd = this.header.getBoundingClientRect().top + totalHeight;
      document.documentElement.style.setProperty(
        "--header-end",
        `${headerEnd.toFixed(1)}px`
      );
      document.documentElement.style.setProperty(
        "--content-start",
        `${totalHeight.toFixed(1)}px`
      );
    }

    setHeaderEnd() {
      requestAnimationFrame(() => this.updateHeaderOffsets());
    }
  }

  class ConvxMobileNav extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector(".convx__mobile-menu"); // adjust if needed
      this.hamburger = document.querySelector("#convx_nav-hamburger");
    }

    connectedCallback() {
      this.initDrawerToggle();
      this.initNavLinks();
      this.initAccordions();
      this.initBackButtons();
    }

    closeDrawer() {
      if (!this.drawer || !this.drawer.classList.contains("active")) return;

      this.drawer.classList.remove("active");
      this.hamburger.classList.remove("active");
      document.body.classList.remove("drawer-open");
      document.body.classList.add("drawer-closing");
      setTimeout(() => document.body.classList.remove("drawer-closing"), 300);

      const shoppingBar = document.querySelector(".shopping-bar");
      if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
      const announcementBar = document.querySelector(".announcement-bar");
      if (announcementBar) announcementBar.classList.remove("annoucment-bar-top");
      const menuBar = document.querySelector(".header-sticky-wrapper");
      if (menuBar) menuBar.classList.remove("menu-bar-top");

      const siteHeader = document.querySelector(".header-wrapper--sticky .site-header");
      if (siteHeader) {
        requestAnimationFrame(() => {
          const scrollTop = document.documentElement.scrollTop;
          if (scrollTop > 200) {
            siteHeader.classList.add("active");
          } else {
            siteHeader.classList.remove("active");
          }
        });
      }

      const logo = document.querySelectorAll(".site-header__logo img");
      if (logo) logo.forEach((item) => item.classList.remove("active"));
      const icons = document.querySelectorAll(".header-item--icons a.site-nav__link");
      if (icons) icons.forEach((item) => item.classList.remove("active"));

      this.querySelectorAll(".convx__mobile-sub-menu.active").forEach(
        (menu) => menu.classList.remove("active")
      );
      this.querySelectorAll(".convx__mobile-nav-link.active").forEach(
        (link) => link.classList.remove("active")
      );
      this.querySelectorAll(".convx__dropdown-panel.active").forEach(
        (panel) => panel.classList.remove("active")
      );
      this.querySelectorAll(".convx__dropdown-accordion.active").forEach(
        (accordion) => accordion.classList.remove("active")
      );
    }

    initDrawerToggle() {
      if (!this.hamburger || !this.drawer) return;

      document.addEventListener("predictive-search:open", () => {
        this.closeDrawer();
      });

      this.hamburger.addEventListener("click", () => {
        const siteHeader = document.querySelector(
          ".header-wrapper--sticky .site-header"
        );
        const logo = document.querySelectorAll(".site-header__logo img");
        const icons = document.querySelectorAll(
          ".header-item--icons a.site-nav__link"
        );
        const shoppingBar = document.querySelector(".shopping-bar");
        if (shoppingBar) shoppingBar.classList.add("hide-shopping-bar");
        const announcementBar = document.querySelector(".announcement-bar");
        if (announcementBar) announcementBar.classList.add("annoucment-bar-top");
        const menuBar = document.querySelector(".header-sticky-wrapper");
        if (menuBar) menuBar.classList.add("menu-bar-top");
        if (typeof window.stickyHeaderCheck === "function") {
          window.stickyHeaderCheck();
        }
        const isOpen = this.drawer.classList.toggle("active");

        if (siteHeader) {
          if (isOpen) {
            siteHeader.classList.add("active");
          } else {
            requestAnimationFrame(() => {
              const scrollTop = document.documentElement.scrollTop;

              if (scrollTop > 200) {
                siteHeader.classList.add("active");
              } else {
                siteHeader.classList.remove("active");
              }
            });
          }
        } if (logo)
          logo.forEach((item) => {
            item.classList.toggle("active");
          });
        if (icons)
          icons.forEach((item) => {
            item.classList.toggle("active");
          });

        this.hamburger.classList.toggle("active");

        document.body.classList.toggle("drawer-open", isOpen);

        if (!isOpen) {
          document.body.classList.add("drawer-closing");

          setTimeout(() => {
            document.body.classList.remove("drawer-closing");
          }, 300); // match your drawer animation duration
          const shoppingBar = document.querySelector(".shopping-bar");
          if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
          const announcementBar = document.querySelector(".announcement-bar");
          if (announcementBar) announcementBar.classList.remove("annoucment-bar-top");
          const menuBar = document.querySelector(".header-sticky-wrapper");
          if (menuBar) menuBar.classList.remove("menu-bar-top");
          // Close all submenus
          this.querySelectorAll(".convx__mobile-sub-menu.active").forEach(
            (menu) => menu.classList.remove("active")
          );

          // Remove active state from nav links
          this.querySelectorAll(".convx__mobile-nav-link.active").forEach(
            (link) => link.classList.remove("active")
          );

          // Close all accordion panels
          this.querySelectorAll(".convx__dropdown-panel.active").forEach(
            (panel) => panel.classList.remove("active")
          );

          // Remove active from accordions
          this.querySelectorAll(".convx__dropdown-accordion.active").forEach(
            (accordion) => accordion.classList.remove("active")
          );
        }
      });
    }

    initNavLinks() {
      const navLinks = this.querySelectorAll(".convx__mobile-nav-link");

      navLinks.forEach((link) => {
        const reference = link.getAttribute("data-mobile-nav-reference");

        link.addEventListener("click", (e) => {
          const subMenu = this.querySelector(
            `.convx__mobile-sub-menu[data-mobile-nav-reference="${reference}"]`
          );

          if (subMenu) {
            e.preventDefault();
            e.stopPropagation();

            subMenu.classList.toggle("active");
            link.classList.toggle("active");
          }
        });
      });
    }

    initAccordions() {
      const accordions = this.querySelectorAll(".convx__dropdown-accordion");

      accordions.forEach((accordion) => {
        accordion.addEventListener("click", () => {
          const panel = accordion.nextElementSibling;

          // Close others
          // this.querySelectorAll(".convx__dropdown-panel").forEach((p) => {
          //   if (p !== panel) p.classList.remove("active");
          // });

          // this.querySelectorAll(".convx__dropdown-accordion").forEach((a) => {
          //   if (a !== accordion) a.classList.remove("active");
          // });

          // Toggle current
          panel.classList.toggle("active");
          accordion.classList.toggle("active");
        });
      });
    }

    initBackButtons() {
      const backButtons = this.querySelectorAll(".convx__back-button");

      backButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const submenu = button.closest(".convx__mobile-sub-menu");
          if (submenu) submenu.classList.remove("active");

          // Also deactivate the corresponding nav link
          const reference = submenu.getAttribute("data-mobile-nav-reference");
          const matchingNavLink = this.querySelector(
            `.convx__mobile-nav-link[data-mobile-nav-reference="${reference}"]`
          );
          if (matchingNavLink) matchingNavLink.classList.remove("active");
        });
      });
    }
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    if (!customElements.get("convx-desktop-nav")) {
      customElements.define("convx-desktop-nav", ConvxDesktopNav);
    }

    if (!customElements.get("convx-mobile-nav")) {
      customElements.define("convx-mobile-nav", ConvxMobileNav);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
